/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import styled from "styled-components";
import {colors} from "nxtconstants";

const LogoWrapper = styled.div`
	margin: 0 auto;
	padding: 2rem;
	width: 98%;
`;

const LogoImage = styled.img``;

const StaticWrapper = styled.div`
	max-width: 1250px;
	margin: 0 auto;
	font-size: 1.6rem;
	line-height: 1.8;
`;

const StaticContent = styled.div`
	max-width: 950px;
	margin: 0 auto;
	padding: 0 3rem;

	&.screenshots-wrapper {
		img {
			width: 100%;
			max-width: 320px;
			display: block;
			margin: 2rem 0;

			&.w-100 {
				max-width: 100%;
				border-radius: 5px;
			}
		}
	}

	&.tabContent {
		display: none;
	}
	&.showTab {
		display: block;
	}

	&.sebi-awarness-saarthi-download-app {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		gap: 2rem;
      a {
      gap: 2rem;
      margin: 2rem 0;

      img {
        width: 100px;
       }
     }
	}


	@media (max-width: 768px) {
		padding: 0 2rem;
	}
	h2, h3, h4 {
		font-size: 3rem;
		padding-bottom: 1rem;
		color: #333;
	}
	h3, h4 {
		font-size: 2.2rem;
	}
	span.highlight {
			background-color: yellow;
			color: #000;
	}
	p {
		color: #666;
		margin-bottom: 1rem;
		word-break: break-word;
		span {
			color: #000;
			font-size: 1.1em;
		}
		&.highlight {
			background-color: yellow;
			width: fit-content;
			padding: 0 2rem;
			color: #000;
		}
	}
	ol {
		padding: 2rem 0 2rem 2rem;
		color: #666;
	}
	ul {
		padding: 2rem 0;
		li {
			position: relative;
			padding-left: 3.5rem;
			&:before {
				content: '';
				position: absolute;
				left: 12px;
				top: 9px;
				height: 1rem;
				width: 1rem;
				border-radius: 100%;
				background-color: ${colors.primary};
				opacity: 0.5;
			}
			&.sublist {
				margin-left: 3.5rem;
			}
		}
	}
	a {
		color: ${colors.primary};
	}
	img {
		width: 100%;
	}
`;

const ContentSection = styled.section`
	padding: 5rem 0;
	&:first-child{
		padding-top: 10rem;
	}
	&:last-child{
		padding-bottom: 10rem;
	}
	&.pt-5{
		&:first-child{
		padding-top: 5rem;
	}
	}
`;

const SaarthiContentSection = styled.section`
	padding: 5rem 0;

	p {
		font-size: 2rem;
	}
	&:first-child{
		padding-top: 5rem;
	}
	&:last-child{
		padding-bottom: 10rem;
	}
	&.pt-5{
		&:first-child{
		padding-top: 5rem;
	}
	}
	&.saarthi-key-features {

	}
`;

const TabList = styled(StaticContent)`
	padding-top: 5rem;
	display: flex;
	border-bottom: 1px solid rgba(103, 37, 244, 0.15);
	padding-left: 0;

	& + div > section:first-child {
		padding-top: 2rem;
	}
`;

const TabItem = styled.a`
	display: block;
	padding: 1rem 4rem;
	border-bottom: 2px solid transparent;
	font-weight: 600;
	color: #222!important;
	font-size: 2.2rem;
	cursor: pointer;

	&:not(:last-child) {
		margin-right: 2rem;
	}

	&.active {
		color: ${colors.primary}!important;
		border-color: ${colors.primary};
		cursor: default;
	}
`;

const TableResponsive = styled.div`
	width: 100%;
	overflow-x: auto;

  @media (max-width:768px){
	width: 90%;
	margin: 0 auto;
	}
`;

const Table = styled.table`
	width: 100%;
	border-collapse: collapse;
	td, th {
		padding: 13px 21px;
		text-align: left;
		width: fit-content;
		ul {
			padding: 0;
		}
		p{
			color: initial;
			&:last-child{
				margin: 0;
			}
		}
	}
	thead th {
		color: ${colors.primary};
		font-size: 2.2rem;
		border-bottom: 1px solid rgba(103, 37, 244, 0.5);
	}
	th{
		color: ${colors.primary};
	}
`;

const TableStriped = styled(Table)`
	tbody tr:nth-child(odd) {
		background-color: rgba(103, 37, 244, 0.04);
	}
`;

const PageHeader = styled.h1`
	padding: 7rem 0;
	color: #222;
	text-align: center;
	font-size: 5rem;

	@media (max-width:768px){
		padding: 4rem 0;
		font-size: 4rem;
	}
`;

const DividerLine = styled.div`
	width: 100%;
	height: 1px;
	background-color: rgba(103, 37, 244, 0.15);
`;

export {
  LogoWrapper,
  LogoImage,
  StaticWrapper,
  PageHeader,
  DividerLine,
  TableResponsive,
  Table,
  TableStriped,
  StaticContent,
  TabList,
  TabItem,
  ContentSection,
  SaarthiContentSection
};
